import {AssayResultValidation, AssayValidationChange} from './ValidationConstants';

export function getLastAssayValidationChangeForField(
  assayResultValidation: AssayResultValidation,
  schemaFieldId: string
): AssayValidationChange | null {
  const assayValidationHistory = assayResultValidation.fieldValidation[schemaFieldId].history;
  return assayValidationHistory.length > 0 ? assayValidationHistory[assayValidationHistory.length - 1] : null;
}
